<template>
  <popup class="churn-popup" :close-action="closePopup">
    <template v-slot:content>
      <churn-step1 :next-step="nextStep" :close="close" v-if="step === 1"/>
      <churn-step2 :next-step="nextStep" v-else-if="step === 2"/>
      <churn-step3 :next-step="churn" v-else-if="step === 3"/>
    </template>
    <template v-slot:footer>
      <div class="cancel" v-on:click="close">
        <span class="delete-text">בפעם אחרת</span>
      </div>
    </template>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import router from '@/router';
import Segment from '@/Segment';
import ChurnStep1 from './ChurnStep1.vue';
import ChurnStep2 from './ChurnStep2.vue';
import ChurnStep3 from './ChurnStep3.vue';

export default {
  name: 'ChurnPopup',
  components: {
    Popup: BaseUI.Popup,
    ChurnStep1,
    ChurnStep2,
    ChurnStep3,
  },
  created() {
    Segment.trackUserInteraction('ChurnPopup_Shown');
  },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    ...mapActions('churn', ['churnCustomer']),
    ...mapActions('churnSurvey', ['saveChurnSurveyDetails']),
    closePopup() {
      Segment.trackUserInteraction('ChurnPopup_CloseClicked');
      this.close();
    },
    close() {
      this.$emit('close');
    },
    nextStep() {
      this.step++;
    },
    async churn() {
      await this.saveChurnSurveyDetails();
      this.close();
      this.churnCustomer();
      await router.push({ path: '/goodbye' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.churn-popup.popup {
  ::v-deep .top .content {
    margin-bottom: 0;
  }

  .cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .delete-text {
      color: $riseup_black;
      font-size: 18px;
      font-weight: normal;
    }
  }
}
</style>
